// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { load } from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/product-form/product-form';
import 'snippets/size-guide/size-guide';
import 'snippets/luggage-size-guide/luggage-size-guide';
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/main-product/main-product';
import 'sections/rebuy-product-widget/rebuy-product-widget';
import 'sections/product-recommendations/product-recommendations';
import 'sections/faq/faq';

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});